
const onPlaying           = 'onPlaying';
const onStop              = 'onStop';
const onResizeInit        = 'onResizeInit';
const onResizeEnd         = 'onResizeEnd';
const onActive            = 'onActive';

const EVENT_PLAYING       = new CustomEvent( onPlaying , {
  bubbles: true ,
  cancelable: true ,
  detail: { playing: true },
} );

const EVENT_STOP          = new CustomEvent( onStop , {
  bubbles: true ,
  cancelable: true ,
  detail: { playing: false } ,
} );

const EVENT_RESIZE_INIT   = new Event( onResizeInit );
const EVENT_RESIZE_END    = new Event( onResizeEnd );

export { onPlaying , onStop , onResizeInit , onResizeEnd , onActive , EVENT_PLAYING , EVENT_STOP , EVENT_RESIZE_INIT , EVENT_RESIZE_END };
